export function groupExpiredDocuments(rows) {
  const groups = new Map();
  rows.forEach(({ candidate, document }) => {
    if (!candidate?._id || !document) return;
    if (!groups.has(candidate._id)) groups.set(candidate._id, { candidate, documents: [] });
    groups.get(candidate._id).documents.push(document);
  });
  return Array.from(groups.values()).map(group => ({ ...group, documents: group.documents.sort((a, b) => String(a.expirationDate).localeCompare(String(b.expirationDate))) }));
}
